export class CategoryEventResponse {
  idCategory: number;
  name: string;
  position: number;
  showOnBillboard: boolean;
  quantityEvents: number;
  tenant: number;
}
